export const CitizenScienceDataflowConfig = {
  getAll:
    '/dataflow/citizenScienceDataflows?asc={:isAsc}&pageNum={:pageNum}&orderHeader={:sortBy}&pageSize={:numberRows}'
};
